

const apptheme = {
    primaryColor: '#008F7B',
    secondaryColor: '#F5F7F6',
    tertiaryColor: '#006B5C',
    quaternaryColor: '#B67F35',
    quintenaryColor: '#6DA17E',
    senaryColor: '#4B6B57',
    septenary: '#707070'

}

export default apptheme
